<template>
  <BDataTable :client="invoiceClient" :showFooter="true">
    <template v-slot:header>
      <div
        class="px-4 py-3 grid grid-cols-12 grid-flow-col text-sm uppercase font-medium bg-gray-50 border-b border-gray-200"
      >
        <div class="col-span-4 sm:col-span-3 md:col-span-2">Rechnung</div>
        <div class="col-span-5 sm:col-span-3 md:col-span-3">Veranstaltung</div>
        <div class="col-span-5 md:col-span-3 hidden md:block">Rechnungsdatum</div>
        <div class="col-span-3 sm:col-span-2 hidden sm:block">Betrag</div>
        <div class="col-span-3 sm:col-span-2 text-right">Status</div>
      </div>
    </template>

    <template v-slot:table="{ item }">
      <a
        :href="item.url"
        target="_blank"
        class="px-4 py-2 grid grid-cols-12 items-center border-b border-gray-200 hover:bg-gray-50"
      >
        <div class="col-span-4 sm:col-span-3 md:col-span-2 font-medium">
          {{ item.name }}
        </div>

        <div class="col-span-5 sm:col-span-3 md:col-span-3">
          {{ item.event_title }}
        </div>

        <div class="row-start-2 md:row-start-auto col-span-5 md:col-span-3">
          {{ formatDateForHuman(item.invoice_date) }}
        </div>

        <div class="col-span-3 sm:col-span-2 hidden sm:block">
          {{ item.amount_total_signed | decimalCurrency }}
        </div>

        <div class="col-span-3 sm:col-span-2 text-right">
          <badge
            :text="item.payment_state == 'paid' ? 'Abgerechnet' : 'Ausstehend'"
            :type="item.payment_state == 'paid' ? 'success' : 'warning'"
            class="px-1 md:px-4"
          ></badge>
        </div>
      </a>
    </template>
  </BDataTable>
</template>

<script>
import invoiceClient from '@/api/central/invoices';
import { BDataTable } from '@/components/BDataTable';
import Badge from '@/components/Badge';
import InteractsWithDates from '@/mixins/InteractsWithDates';

export default {
  components: { Badge, BDataTable },

  props: {
    events: {
      type: String,
      default: null,
    },
  },

  mixins: [InteractsWithDates],

  methods: {
    invoiceClient({ page, resolve }) {
      return invoiceClient
        .index({ page, ...(this.events ? { event: this.events } : {}) }) // Merge events if provided
        .then(({ data }) => {
          resolve(data);
        });
    },
  },
};
</script>